var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLeonInmobiliariaIconsClose = function SvgLeonInmobiliariaIconsClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "leon-inmobiliaria-icons-close_svg__close",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".leon-inmobiliaria-icons-close_svg__cls-1{fill:none;stroke:currentcolor;stroke-width:12.47px}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "leon-inmobiliaria-icons-close_svg__Gruppe_9193",
    "data-name": "Gruppe 9193"
  }, /*#__PURE__*/React.createElement("path", {
    className: "leon-inmobiliaria-icons-close_svg__cls-1",
    d: "m10.79 10 78.42 78.43",
    id: "leon-inmobiliaria-icons-close_svg__Linie_69",
    "data-name": "Linie 69"
  }), /*#__PURE__*/React.createElement("path", {
    className: "leon-inmobiliaria-icons-close_svg__cls-1",
    d: "m10.79 90 78.42-78.43",
    id: "leon-inmobiliaria-icons-close_svg__Linie_70",
    "data-name": "Linie 70"
  }))));
};
export default SvgLeonInmobiliariaIconsClose;